const validUrls = [
  'https://core-store-dev-au.apps.ad.corelogic.asia/',
  'https://corestore-uat.corelogic.com.au/',
  'https://www.corelogic.com.au/',
  'http://confluence.ad.corelogic.asia/',
  'https://www.cotality.com',
  'https://www.cotality.com/au'
]


const SAFE_PATH_PATTERN = /^\/[^<>"'`]*$/;

const clearQueryParams = () => {
  const { pathname } = window.location;
  if (SAFE_PATH_PATTERN.test(pathname)) {
    window.history.replaceState(null, null, pathname);
  }
};

const isValidUrl = (url) => {
  return validUrls.find(x => (url.startsWith(x))) ? true : false
}

const isEmptyStates = (states) => states === null || states === undefined || states.filter(Boolean).length === 0;

// Products without a geography (e.g. Commercial, Blockbrief) don't require state selection
const isStatesMissing = (quoteServiceType, configuration) => {
  const { geography, package: packageName } = configuration;
  if (!geography) {
    return false;
  }
  if (quoteServiceType === 'RPPRealEstate') {
    return isEmptyStates(geography.states) && geography.national === false && packageName !== 'trial';
  }
  return isEmptyStates(geography.states);
};

export { clearQueryParams, isValidUrl, isStatesMissing };

